import { Button, Card, Col, Collapse, Divider, Progress, Row, Space, Typography } from 'antd'
import { useEffect, useState } from 'react';
import { NavLink, useParams } from 'react-router-dom';
import { FilePdfOutlined, FileOutlined, QuestionCircleOutlined, LaptopOutlined, PlaySquareOutlined } from '@ant-design/icons';
import CourseService from '../services/CourseService';
import { formatNumber, transformData } from '../utils';
import PaymentModal from '../components/Packages/PaymentModal';
import { ReactComponent as DocIcon } from '../assets/icons/course/doc.svg';
import { ReactComponent as ExplanationIcon } from '../assets/icons/course/explanation.svg';
import { ReactComponent as QuestionIcon } from '../assets/icons/course/question.svg';
import { ReactComponent as VideoIcon } from '../assets/icons/course/video.svg';
import CourseCover from '../assets/course-cover.svg'
import LearnSidebar from '../components/Learn/LearnSidebar';
import PaymentService from '../services/PaymentService';
import React from 'react';
import VideoHistoryService from '../services/VideoHistoryService';
import { transformDataNew } from '../transformData';


const LearnDetail = () => {
    const { Title, Text } = Typography;
    const [loading, setLoading] = useState<boolean>();
    const [course, setCourse] = useState<any>();
    const [groups, setGroups] = useState<any>([])
    const [buyer, setBuyer] = useState<any>({});
    const { courseId } = useParams()
    const [totalVideo, setTotalVideo] = useState(0);
    const [totalDocument, setTotalDocument] = useState(0);
    const [totalQuestion, setTotalQuestion] = useState(0);
    const [totalSubject, setTotalSubject] = useState(0);
    const [checkoutFormContent, setCheckoutFormContent] = useState<string | null>(null);
    const [watchedVideoList, setWatchedVideoList] = useState<any[]>([]);

    useEffect(() => {
        getAllMeByCourse()
    }, [])

    const getAllMeByCourse = () => {
        setGroups([]);
        VideoHistoryService.getAllMeByCourse(courseId)
            .then((response: any) => {
                setWatchedVideoList(response.data);
                getPackageDetail()
            })
            .catch((e: Error) => {
                console.log(e);
            });
    };

    const getPackageDetail = async () => {
        setLoading(true);
        CourseService.getDetail(courseId)
            .then((response: any) => {
                setGroups(response.data.groups);
                setCourse(response.data);
                setLoading(false);
                setTotalVideo(response.data.totalVideo);
                setTotalDocument(response.data.totalDocument);
                setTotalQuestion(response.data.totalQuestion);
                const allSubjects = response.data.groups.flatMap((group: any) => group.subjects);
                setTotalSubject(allSubjects.length);
            })
            .catch((e: Error) => {
                console.log(e);
                setLoading(false);
            });
    }

    const subjectRender = () => {
        return (
            <>
                {groups?.map((groupItem: any, index: number) => {
                    const transformedSubjects = transformDataNew(groupItem.subjects, watchedVideoList);
                    return (
                        <React.Fragment key={index}>
                            <div style={{ background: "#ff854b", paddingBottom: 12 }}>
                                <Title level={3} style={{ paddingLeft: 16, margin: 0, padding: 16, color: '#fff', background: '#7c5dff' }}>{groupItem.name}</Title>
                            </div>
                            <LearnSidebar subjects={transformedSubjects}></LearnSidebar>
                        </React.Fragment>
                    );
                })}
            </>
        );
    };

    return (
        <>
            {(course?.name) && <Row gutter={[16, 16]}>
                <Col xs={24} md={24} lg={24}>
                    <Row className='mb-16' justify={"space-between"} align={"middle"}>
                        <Col>
                            <Title className='m-0' level={4}>{course?.name}</Title>
                        </Col>
                        <Col>
                            <NavLink to={'/'}>
                                <Button type="default" size='large'>
                                    Geri
                                </Button>
                            </NavLink>
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]}>
                        <Col span={24}>
                            <Card loading={loading} style={{ background: "none" }} bodyStyle={{ padding: '10px 0px', background: "none" }}>
                                {subjectRender()}
                            </Card>
                        </Col>
                    </Row>
                </Col>
                {/* <Col xs={24} md={12} lg={6}>
                    <div style={{ position: 'sticky', top: '16px' }}>
                        <Card
                            loading={loading}
                            bodyStyle={{ padding: 16, height: '100%', paddingTop: 0, flex: '1 1 auto' }}
                            className={`course-card ${course?.free ? 'free' : 'paid'}`}
                        >
                            <Title level={4}>{course?.name}</Title>
                            <Row>
                                <Col>
                                    <div dangerouslySetInnerHTML={{ __html: course?.subhead }} />
                                </Col>
                            </Row>
                        </Card>
                    </div>
                </Col> */}
            </Row>
            }
        </>
    )
}

export default LearnDetail